import { ShopifySaleService } from 'src/app/services/shopify-sale.service';
import { DeliveryService } from 'src/app/services/delivery.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Delivery } from 'src/app/models/delivery.schema';
import { ShowImageComponent } from '../show-image/show-image.component';
import { MatDialog } from '@angular/material/dialog';
import { Service } from 'src/app/services/service.service';
import { ServiceModel } from 'src/app/models/service.schems';
import { AuthService } from './../../services/auth.service';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { CakeSaleService } from 'src/app/services/cake-sale.service';
import { BusinessSaleService } from 'src/app/services/business-sale.service';
import { FlowersSaleService } from 'src/app/services/flowers-sale.service';
import { DeluxyExperienceSalesService } from 'src/app/services/deluxy-experience-sales.service';
import { DeluxyDotComSalesService } from 'src/app/services/deluxy-dot-com-sales.service';
import { Product } from 'src/app/models/product.schema';
import { PartnerService } from 'src/app/services/partner.service';
import { MapHelperService } from 'src/app/helpers/maps-service-helpher.service';
import { CommanUsesService } from 'src/app/services/comman-uses.service';

@Component({
  selector: 'app-confirm-sale',
  templateUrl: './confirm-sale.component.html',
  styleUrls: ['./confirm-sale.component.scss']
})
export class ConfirmSaleComponent implements OnInit {

  decodedInfo: any;
  isTokenExpire: boolean = false;
  delivery: Delivery;
  disableProposeSaleBtn: boolean = false;
  totalProductPrice: number = 0;
  token: string;
  disablebtn: boolean = false;
  deliveryId: number;
  public services :ServiceModel[] = [];
  public serviceDetails:any;

  // Multi-address modal properties
  showAddressModal: boolean = false;
  selectedPickupAddress: string | null = null;
  isConfirming: boolean = false;
  partnerPickupAddresses: string[] = [];
  selectedPartner: any = null;
  partnerHasMultipleAddresses: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private jwtHelper: JwtHelperService,
    private deliveryService: DeliveryService,
    private shopifySaleService: ShopifySaleService,
    private cakeSaleService: CakeSaleService,
    private businessSaleService: BusinessSaleService,
    private flowersSaleService: FlowersSaleService,
    private deluxyExperienceSalesService: DeluxyExperienceSalesService,
    private deluxyDotComSalesService: DeluxyDotComSalesService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private service: Service,
    private router: Router,
    private authService: AuthService,
    private authStatusService: AuthStatusService,
    private partnerService: PartnerService,
    private mapHelperService: MapHelperService,
    private commanUsesService: CommanUsesService,
  ) { }

  async ngOnInit() {
    await this.initialize();
  } 

  async initialize(){
    try {
      const token: string = this.route.snapshot.paramMap.get('token');
      this.token = token;
      this.isTokenExpire = this.jwtHelper.isTokenExpired(token);
      if(this.isTokenExpire){
        this.showSnackBar('Sale has been expired');
        this.disableProposeSaleBtn = true;
        return false;
      }
      this.decodedInfo = this.jwtHelper.decodeToken(token);
      this.deliveryId = this.decodedInfo?.deliveryId;
      let data: any;
      if(this.decodedInfo?.saleType){
        if(this.decodedInfo?.saleType?.toLowerCase() === 'shopifysale'){
          data = await this.shopifySaleService.findSaleDelivery(token);
        }
        if(this.decodedInfo?.saleType?.toLowerCase() === 'cakesales'){
          data = await this.cakeSaleService.findSaleDelivery(token);
        }
        if(this.decodedInfo?.saleType?.toLowerCase() === 'flowerssales'){
          data = await this.flowersSaleService.findSaleDelivery(token);
        }
        if(this.decodedInfo?.saleType?.toLowerCase() === 'businesssales'){
          data = await this.businessSaleService.findSaleDelivery(token);
        }
        if(this.decodedInfo?.saleType?.toLowerCase() === 'deluxyexperiencesales'){
          data = await this.deluxyExperienceSalesService.findSaleDelivery(token);
        }
        if(this.decodedInfo?.saleType?.toLowerCase() === 'deluxydotcomsales'){
          data = await this.deluxyDotComSalesService.findSaleDelivery(token);
        }
      }
      // data = await this.shopifySaleService.findSaleDelivery(token);
      if(data === null){
        this.showSnackBar('Sale has been alreday accepted or refused');
        return false;
      }
      const parsedDelivery = JSON.parse(data?.deliveryInfo || '{}');
      if (data?.partner) {
        parsedDelivery.partner = { ...(parsedDelivery.partner || {}), ...data.partner };
      }
      this.delivery = parsedDelivery;
      this.getTotalOfProduct();
    } catch (error) {
      console.log("error", error)
    }
  }

  async getTotalOfProduct(){
    /*
    if(this.delivery?.deliveryProducts){
      this.delivery?.deliveryProducts.forEach((product) => {
        this.totalProductPrice += Number(product?.product?.price)
      })
    }
    */
   
    this.delivery.deliveryProducts.forEach((item) => {
      const product: Product = item?.product || {};
      const variant = item?.productVariant || null;

      const unitPrice = variant?.variantPrice
        ? Number(variant.variantPrice)
        : Number(product.price || '0');

      const quantity = Number(item.quantity || 1);
      const validQuantity = isNaN(quantity) || quantity <= 0 ? 1 : quantity;

      const validPrice = isNaN(unitPrice) || unitPrice <= 0 ? 0 : unitPrice;

      this.totalProductPrice += validPrice * validQuantity;
    });
  }

  async acceptSale(){
    console.log('acceptSale clicked', this.delivery?.partner);
    try {
      if(this.isTokenExpire){
        this.showSnackBar('Sale has been expired');
        return;
      }
      if(!this.disableProposeSaleBtn){
        // Check if partner has multiple pickup addresses and show modal if needed
        if (this.delivery?.partner) {
          await this.openAddressSelectionModal(this.delivery.partner?.id);
        } else {
          // If no partner data, proceed directly
          await this.proceedWithAcceptSale();
        }
      }
    } catch (error) {
      this.disablebtn = false;
      if(error.error?.message === 'ALREDAY_ACCEPTED'){
        this.showSnackBar('Sale has been already accepted');
      } else if(error.error?.message === 'SALE_SERVICE_NOT_AVAILABLE') {
        this.showSnackBar('Partner has not sale type service. Can not accept sale');
      } else {
        this.showSnackBar('Something went wrong');
      }
    }
  }

  async refuseSale(){
    try {
      if(this.isTokenExpire){
        this.showSnackBar('Sale has been expired');
        return;
      }
      if(!this.disableProposeSaleBtn){
        if (!confirm("Confermi di rifiutare la vendita?"))
          return;
        this.disablebtn = true;
        let result: any;
        if(this.decodedInfo?.saleType){
          if(this.decodedInfo?.saleType?.toLowerCase() === 'shopifysale'){
            result = await this.shopifySaleService.refuseSale(this.token, this.deliveryId);
          }
          if(this.decodedInfo?.saleType?.toLowerCase() === 'cakesales'){
            result = await this.cakeSaleService.refuseSale(this.token, this.deliveryId);
          }
          if(this.decodedInfo?.saleType?.toLowerCase() === 'flowerssales'){
            result = await this.flowersSaleService.refuseSale(this.token, this.deliveryId);
          }
          if(this.decodedInfo?.saleType?.toLowerCase() === 'businesssales'){
            result = await this.businessSaleService.refuseSale(this.token, this.deliveryId);
          }
          if(this.decodedInfo?.saleType?.toLowerCase() === 'deluxyexperiencesales'){
            result = await this.deluxyExperienceSalesService.refuseSale(this.token, this.deliveryId);
          }
          if(this.decodedInfo?.saleType?.toLowerCase() === 'deluxydotcomsales'){
            result = await this.deluxyDotComSalesService.refuseSale(this.token, this.deliveryId);
          }
        }
        // let promise = this.deliveryService.refuseSale(this.token, this.deliveryId);
        if(result){
          // console.log("result", result);
          this.delivery = null;
          await this.initialize();
          this.showSnackBar('Sale has been refused');
          this.disablebtn = false;
        }
      }
    } catch (error) {
      this.showSnackBar('Something went wrong');
      this.disablebtn = false;
    }
  }

  showImage(product: any){
    let ref = this.dialog.open(ShowImageComponent, { panelClass: 'partner-time-dialog', width: '50vw', data: { product } });
    ref.afterClosed().subscribe(result => {});
  }

  openImage(imageUrl: string) {
    if (imageUrl) {
      window.open(imageUrl, '_blank');
    }
  }

  async showSnackBar(message: string) {
    this._snackBar.open(message, 'Chiudi', {
      direction: "ltr",
      duration: 2000,
      horizontalPosition: "center",
      politeness: "assertive",
      verticalPosition: "top"
    });
  }

  handleAddressModal() {
    this.showAddressModal = !this.showAddressModal;
  }

  async checkPartnerMultipleAddresses(partnerId?: number) {
    try {
      const deliveryPartner = this.delivery?.partner || null;
      if (deliveryPartner?.pickupAddresses && deliveryPartner.pickupAddresses.length > 0) {
        this.selectedPartner = deliveryPartner;
        this.partnerPickupAddresses = deliveryPartner.pickupAddresses;
        this.partnerHasMultipleAddresses = true;
        return true;
      }

      if (partnerId) {
        const partner = await this.partnerService.getOne(partnerId);
        if (partner && partner.pickupAddresses && partner.pickupAddresses.length > 0) {
          this.selectedPartner = partner;
          this.partnerPickupAddresses = partner.pickupAddresses;
          this.partnerHasMultipleAddresses = true;
          return true;
        }
      }

      this.partnerHasMultipleAddresses = false;
      return false;
    } catch (error) {
      console.log("Error checking partner addresses:", error);
      const deliveryPartner = this.delivery?.partner || null;
      if (deliveryPartner?.pickupAddresses && deliveryPartner.pickupAddresses.length > 0) {
        this.selectedPartner = deliveryPartner;
        this.partnerPickupAddresses = deliveryPartner.pickupAddresses;
        this.partnerHasMultipleAddresses = true;
        return true;
      }

      this.partnerHasMultipleAddresses = false;
      return false;
    }
  }

  async confirmPickupAddress() {
    if (this.selectedPartner && this.selectedPickupAddress) {
      this.isConfirming = true;
      try {
        this.delivery.pickUpAddress = this.selectedPickupAddress;
        console.log('delivery.partner', this.delivery?.partner);


        const geoCodedAddress = await this.mapHelperService.geoCodeAddress(this.selectedPickupAddress);
        if (geoCodedAddress && geoCodedAddress.length > 0) {
          console.log("Geocoded address:", geoCodedAddress[0]);
        }
        
        this.handleAddressModal();
        this.proceedWithAcceptSale();
      } catch (error) {
        console.error("Error confirming address:", error);
        this.commanUsesService.showSnackBar(`Impossibile confermare l'indirizzo di ritiro. Per favore riprova.`);
      } finally {
        this.isConfirming = false;
      }
    } else {
      this.commanUsesService.showSnackBar(`Seleziona un indirizzo di ritiro prima di confermare.`);
    }
  }

  async openAddressSelectionModal(partnerId?: number) {
    const hasMultiple = await this.checkPartnerMultipleAddresses(partnerId);
    if (hasMultiple) {
      this.handleAddressModal();
    } else {
      this.proceedWithAcceptSale();
    }
  }

  async proceedWithAcceptSale() {
    if (!confirm("Confermi di accettare la vendita?")) {
      return;
    }
    
    this.disablebtn = true;
    let result: any;
    try {
        if (this.decodedInfo?.saleType) {
          if (this.decodedInfo?.saleType?.toLowerCase() === 'shopifysale') {
            result = await this.shopifySaleService.acceptSale(this.token, this.deliveryId, this.delivery);
          }
          if (this.decodedInfo?.saleType?.toLowerCase() === 'cakesales') {
            result = await this.cakeSaleService.acceptSale(this.token, this.deliveryId, this.delivery);
          }
          if (this.decodedInfo?.saleType?.toLowerCase() === 'flowerssales') {
            result = await this.flowersSaleService.acceptSale(this.token, this.deliveryId, this.delivery);
          }
          if (this.decodedInfo?.saleType?.toLowerCase() === 'businesssales') {
            result = await this.businessSaleService.acceptSale(this.token, this.deliveryId, this.delivery);
          }
          if (this.decodedInfo?.saleType?.toLowerCase() === 'deluxyexperiencesales') {
            result = await this.deluxyExperienceSalesService.acceptSale(this.token, this.deliveryId, this.delivery);
          }
          if (this.decodedInfo?.saleType?.toLowerCase() === 'deluxydotcomsales') {
            result = await this.deluxyDotComSalesService.acceptSale(this.token, this.deliveryId, this.delivery);
          }
        }
      if (result) {
        this.delivery = null;
        await this.initialize();
        this._snackBar.open('Sale has been accepted', 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        }).afterDismissed().subscribe(async (res) => {
          if (result?.id) {
            const isLogin: boolean = await this.authStatusService.isAuthenticated();
            let shouldForceLogin = true;

            if (isLogin) {
              const tokenInfo: any = await this.authStatusService.getTokenInfo();
              if (tokenInfo?.extraId && result?.partner?.id && Number(tokenInfo.extraId) === Number(result.partner.id)) {
                shouldForceLogin = false;
              }
            }

            if (shouldForceLogin) {
              let loginInfo: any = await this.authService.forceLogin(result?.partner?.user?.email);
              if (loginInfo) {
                this.authStatusService.setRefreshStorage(loginInfo.refreshToken);
                this.authStatusService.setAccessStorage(loginInfo.accessToken);
              }
            }

            this.router.navigate(['/consegne', result?.id]).then(() => {
              window.location.reload();
            });
          }
        });
        this.disablebtn = false;
      } else {
        this.disablebtn = false;
        this.showSnackBar('Something went wrong');
      }
    } catch (error) {
      this.disablebtn = false;
      if (error.error?.message === 'ALREDAY_ACCEPTED') {
        this.showSnackBar('Sale has been already accepted');
      } else if (error.error?.message === 'SALE_SERVICE_NOT_AVAILABLE') {
        this.showSnackBar('Partner has not sale type service. Can not accept sale');
      } else {
        this.showSnackBar('Something went wrong');
        
      }
    }
  }
}
